import { useEffect } from 'react'
import { message } from 'antd'
import { WARNING_MESSAGE } from '../../constants'

const useCheckPageAccess = ({
  history,
  aclActionsByUser,
  isAccountAdmin,
  actionCode,
}) => {
  useEffect(() => {
    if (aclActionsByUser && aclActionsByUser.length) {
      const hasAccess = aclActionsByUser.some(
        action => action.code === actionCode && action.status === true
      )

      if (!hasAccess && !isAccountAdmin) {
        message.error(WARNING_MESSAGE.ACCESS_PAGE, 3)
        history.push('/dashboard')
      }
    }
  }, [aclActionsByUser, actionCode, isAccountAdmin, history])
}

export default useCheckPageAccess
